import { Slingo } from "@lib/titan2-slingo/dist/api/Slingo";
import { ExtendedChooseCellResponseData } from "../game/model/response/data/ExtendedChooseCellResponseData";
import { ExtendedCollectResponseData } from "../game/model/response/data/ExtendedCollectResponseData";
import { ExtendedCurrentGameResponseData } from "../game/model/response/data/ExtendedCurrentGameResponseData";
import { ExtendedPurchaseEntryResponseData } from "../game/model/response/data/ExtendedPurchaseEntryResponseData";
import { ExtendedSpinResponseData } from "../game/model/response/data/ExtendedSpinResponseData";
import { ExtendedStakeToSpinResponseData } from "../game/model/response/data/ExtendedStakeToSpinResponseData";
import { PawnshopSlingo } from "./PawnshopSlingo";
import { LogResponseData } from "../game/model/response/data/LogResponseData";
Slingo.gameId = "slingo-pawnshop";
Slingo.gameType = "goldfish";
Slingo.requestsMap.getCurrentGame.dataClass = ExtendedCurrentGameResponseData;
Slingo.requestsMap.purchaseEntry.dataClass = ExtendedPurchaseEntryResponseData;
Slingo.requestsMap.spin.dataClass = ExtendedSpinResponseData;
Slingo.requestsMap.chooseCell.dataClass = ExtendedChooseCellResponseData;
Slingo.requestsMap.collect.dataClass = ExtendedCollectResponseData;
Slingo.requestsMap.stakeToSpin.dataClass = ExtendedStakeToSpinResponseData;
PawnshopSlingo.requestsMap.log.dataClass = LogResponseData;
//# sourceMappingURL=ApiPawnshop.js.map